import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { PortfolioProvider } from './context/PortfolioProvider';
import { SocketProvider } from "./context/SocketProvider";
import Landing from "./pages/Landing";
import Market from "./pages/Market";
import Portfolio from "./pages/Portfolio";
import TradeHistory from "./pages/TradeHistory";
import MainNav from "./components/MainNav";

function AppContent() {
  const location = useLocation();
  const hideNavOnRoutes = ['/'];
  const shouldShowNav = !hideNavOnRoutes.includes(location.pathname);

  if (location.pathname === '/') {
    return <Landing />;
  }

  return (
    <SocketProvider>
      <PortfolioProvider>
        {shouldShowNav && <MainNav />}
        <Routes>
          <Route path="/market" element={<Market />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/trade-history" element={<TradeHistory />} />
        </Routes>
      </PortfolioProvider>
    </SocketProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}